import {useRuntimeConfig} from '#imports';
import {name} from '../common';
import {useLocale} from './useLocale';
import {useLocalePrefix} from './useLocalePrefix';

const DEFAULT_LANGUAGE = 'en';
/**
 * Resolves the i18next language to load for the current request.
 *
 * On single-locale hosts, uses the locale cookie language code.
 * On www.malt.com with locale prefix strategy enabled, uses the URL prefix when present; otherwise falls back to English.
 */
export function useResolveTranslationLanguage(): string {
    const {languageCode, isMultiLocaleHost} = useLocale();
    const {getLocalePrefix, getLocaleCodeFromPrefix} = useLocalePrefix();

    // if malt.com
    if (isMultiLocaleHost.value) {
        // if locale prefix strategy is enabled
        const isLocalePrefixStrategyEnabled = !!useRuntimeConfig().public[name]?.enableLocalePrefixStrategy;
        if (isLocalePrefixStrategyEnabled) {
            const localePrefix = getLocalePrefix();
            if (localePrefix) {
                const localeCode = getLocaleCodeFromPrefix(localePrefix);
                const languageCodeFromPrefix = localeCode?.split('-')[0];

                if (languageCodeFromPrefix) {
                    return languageCodeFromPrefix;
                }
            }
        }
        return DEFAULT_LANGUAGE;
    }

    // if localized host
    return languageCode.value ?? DEFAULT_LANGUAGE;
}
